import Duration from '../../../shared/components/Duration/Duration';
import { LATENCY_DEFINITION } from '../../constants/constants';
import { JobLatency } from '../../interfaces/job';

export function LatencyTooltipContent({ latency }: { latency: JobLatency }) {
  return (
    <div className='p-2'>
      <div className='d-flex'>
        <div className='flex-col'>
          <p>Min Latency</p>
          <p>Mean Latency</p>
          <p>Max Latency</p>
        </div>
        <div className='flex-col ml-1'>
          <p>
            -{' '}
            <Duration
              duration={latency.minLatency!}
              options={{ useAbbr: true, separateUnits: true }}
            />
          </p>
          <p>
            -{' '}
            <Duration
              duration={latency.meanLatency!}
              options={{ useAbbr: true, separateUnits: true }}
            />
          </p>
          <p>
            -{' '}
            <Duration
              duration={latency.maxLatency!}
              options={{ useAbbr: true, separateUnits: true }}
            />
          </p>
        </div>
      </div>

      <p className='border px-2 py-1 mt-2'>{LATENCY_DEFINITION}</p>
    </div>
  );
}
